// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@mcmc/XDL/types";

import { IconWrapper } from "@insite/mobius/Icon";
import { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import Caution from "@mcmc/XDL/Icons/Caution";
import Check from "@mcmc/XDL/Icons/Check";
import Close from "@mcmc/XDL/Icons/Close";
import Explanation from "@mcmc/XDL/Icons/Explanation";
import { css } from "styled-components";

export default {
    defaultProps: {
        closeButtonProps: {
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                position: absolute;
                top: 5px;
                right: 5px;
                border: 0;
                width: 30px;
                padding: 0;
            `,
            size: 30,
        },
        closeButtonIconProps: {
            src: Close,
            size: 10,
            color: "text",
            css: css`
                pointer-events: none;
            `,
        },
        bodyTypographyProps: {
            size: "13px",
            lineHeight: "15px",
            forwardAs: "p",
            css: css`
                overflow-wrap: break-word;
                word-wrap: break-word;
                min-width: 0;
                text-align: left;
            `,
        },
        iconSrcByMessage: {
            success: Check,
            warning: Caution,
            danger: Close,
            info: Explanation,
        },
        iconProps: {
            color: "text.inverse",
            size: 24,
            css: css`
                svg {
                    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
                }
                margin-right: 10px;
            `,
        },
        cssOverrides: {
            toast: css`
                background: ${({ messageType, theme }: any) => getContrastColor(messageType, theme)};
                border: 1px solid ${({ messageType, theme }: any) => resolveColor(messageType, theme)};
                opacity: 0.9;
                box-shadow: none;
            `,
            toastBody: css`
                ${IconWrapper as any} {
                    align-self: flex-start;
                }
                & {
                    margin: 14px 25px 14px 20px;
                    width: 100%;
                }
                overflow-wrap: break-word;
                word-wrap: break-word;
                min-width: 0;
            `,
        },
    },
    toasterProps: toasterPropsDefault,
} as xBaseTheme["toast"];
